module.exports = __webpack_public_path__ + "static/media/bg.42373a60.svg";